import { Box, Container, Grid, GridItem, Image, Text } from "@chakra-ui/react";
import IdNumberInput from "../components/IdNumberInput";
import ToggleLanguage from "../components/ToggleLanguage";
import { useEffect, useState } from "react";
function MainContent() {

  const [language, setLanguage] = useState("afrikaans")


  return (
    <Container marginTop={[6,12,25,50]}>
      <Grid  width={[100, 200, 300, 400]}>
        <GridItem>
        </GridItem>
        <GridItem colStart={10}>
        <ToggleLanguage setLanguage={setLanguage} language={language} />
        </GridItem>
      </Grid>
      <GridItem>
      <IdNumberInput language={language} />
      </GridItem>
     
      

     
      
    
    </Container>
  );
}

export default MainContent;